<ul class="breadcrumbs">
    @for (breadcrumb of breadcrumbsService.breadcrumbs$ | async; track breadcrumb?.name) {
        <li>
            @if (breadcrumb?.url) {
                <a class="breadcrumbs__link" routerLink="{{ breadcrumb?.url }}">{{ breadcrumb?.name }}</a>
            } @else {
                {{ breadcrumb?.name }}
            }
        </li>
    }
</ul>
